import { Row } from '@devexpress/dx-react-grid';
import { MainPageContainer, UpperInfoContainer } from 'components/PageLayout';
import { useAllSiteConnectionsReport } from 'pages/hooks';
import { useMemo } from 'react';
import { AxiosError } from 'axios';
import { errorMessages } from 'api/resources/responseMessages/errorMessages';
import { ReportGridContainer } from 'components/ReportGridContainer';
import { NoReportDataMessage } from 'components/ReportsComponents/NoReportDataMessage';
import { ReportBackButton } from 'components/ReportsComponents/ReportBackButton';
import {
  ALL_SITE_CONNECTIONS_REPORT_GRID_TITLE,
  All_SITE_CONNECTION_REPORT,
  columns,
  reportHeaderTagLine,
} from './constants';
import { ReportHeader } from 'components/ReportsComponents/ReportHeader';
import { reportLogger } from 'pages/ReportsDetails/reportLogger';
import { ReportProps } from 'pages/ReportsDetails/types';
import DevExtremeReportGrid from 'components/ReportGrid_New';
import { noPDFexportFormats } from 'components/ReportGrid_New/constants';
import { AllSiteConnectionsInfoMessage } from 'pages/ReportsDetails/All Site Connections/AllSiteConnectionsInfoMessage';


export function AllSitesConnectionReport({
  setErrorMessage,
  setToast,
}: Readonly<ReportProps>) {
  const { isReportFetching, reportData } =
    useAllSiteConnectionsReport(handleError);

  const rows = useMemo<Row>(() => reportData, [reportData]);

  return (
    <MainPageContainer isLoading={isReportFetching} direction="column" wrap="nowrap">
      <UpperInfoContainer direction="column">
        <ReportBackButton />
        <ReportHeader
          reportName={All_SITE_CONNECTION_REPORT}
          infoMessage={<AllSiteConnectionsInfoMessage />}
        />
      </UpperInfoContainer>

      {!isReportFetching && rows?.length === 0 && <NoReportDataMessage />}

      <ReportGridContainer direction="column">
        <DevExtremeReportGrid
          columns={columns}
          displayGroupingPanel
          exportFormats={noPDFexportFormats}
          headerTitleForSheet={All_SITE_CONNECTION_REPORT}
          isLoading={isReportFetching}
          reportHeaderTagLine={reportHeaderTagLine}
          rows={rows}
          title={ALL_SITE_CONNECTIONS_REPORT_GRID_TITLE}
        />
      </ReportGridContainer>
    </MainPageContainer>
  );

  function handleError(error: AxiosError) {
    reportLogger(error);
    setErrorMessage(errorMessages.reports('All site connections Report'));
    setToast(true);
  }
}
